
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { TadsWidgetProvider } from 'react-tads-widget';
import { store } from './store/store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <TadsWidgetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </TadsWidgetProvider>
  </Provider>,
);